import { useEffect, useState } from 'react'

export interface DeclineModalProps {
  open: boolean
  onClose: () => void
  onSubmit: (reason: string) => void
  isSubmitting: boolean
}

export function DeclineModal({ open, onClose, onSubmit, isSubmitting }: DeclineModalProps): JSX.Element | null {
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (!open) return
    function onKey(e: KeyboardEvent): void { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" aria-hidden="true" />
      <div className="relative w-full max-w-md rounded-xl bg-white p-6">
        <h3 className="mb-4 text-lg font-semibold text-gray-900">Decline handoff</h3>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          placeholder="Optional reason (e.g. not at the property yet)"
          className="mb-4 w-full rounded-lg border border-gray-200 p-2 text-sm"
        />
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-lg border border-gray-200 px-4 py-2 text-sm">Cancel</button>
          <button
            type="button"
            disabled={isSubmitting}
            onClick={() => onSubmit(reason)}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white disabled:opacity-60"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  )
}
